/** Must equal the server's `ASSISTANT_MESSAGE_TEXT_MAX_LENGTH`. */
export const ASSISTANT_MESSAGE_MAX_LENGTH = 4000;
export const NEW_CONVERSATION_TITLE = 'New conversation';
/** The synthetic step the server streams with the routing decision; must equal the server name. */
export const UNDERSTAND_REQUEST_TOOL_NAME = 'understand_request';
/**
 * The steps the deterministic meal-analysis reply streams as tool calls; must
 * equal the server's `MealAnalysisStep` names. Together with the routing step
 * and `propose_meal` (only the analysis reply creates it) they are app work,
 * not model work.
 */
export const MEAL_ANALYSIS_STEP_TOOL_NAMES = [
  'analyze_image',
  'identify_foods',
  'resolve_nutrition',
  'estimate_nutrition',
] as const;
